import React from "react";
import { UseFinancialDataResult } from "./useFinancialData";
import WrapErrorLoading from "../../shared/components/WrapErrorLoading";
import { getFinancialTotals, formatNumber } from "./utils";
import gettext from "../../shared/utils/gettext";

interface DashBoardFinancialTileContentProps extends UseFinancialDataResult {
  className?: string;
}

const DashBoardFinancialTileContent = ({
  data,
  error,
  className = "table-condensed table-b-t-0",
}: DashBoardFinancialTileContentProps) => (
  <WrapErrorLoading error={error}>
    {() => {
      if (!data?.pages) return;
      const [costs, revenues] = getFinancialTotals(data);
      const rows: Array<[number, string]> = [
        [revenues, gettext("Revenues")],
        [costs, gettext("Costs")],
        [revenues - costs, gettext("Balance")],
      ];
      return (
        <table className={`table ${className}`}>
          <thead>
            <tr>
              <th>{gettext("Item")}</th>
              <th>{gettext("Amount")}</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(([value, title], i) => (
              <tr key={i}>
                <td>{title}</td>
                <td className="text-right">{formatNumber(value, true, false, 0)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }}
  </WrapErrorLoading>
);

export default DashBoardFinancialTileContent;
